import { Component, Input, Inject } from '@angular/core';
import { BaseButtonSize } from '../../../shared/components/button/base-button.component';
import { PORTAL_SETTINGS } from '../../../core/token/base-config.token';
import { PortalSettings } from '../../../core/types/base-portal-settings.type';

@Component({
  selector: 'base-error-page-header-nav',
  templateUrl: './base-error-page-header-nav.component.html',
})
export class BaseErrorPageHeaderNavComponent {
  @Input() is401 = false;

  buttonSizes = BaseButtonSize;

  constructor(@Inject(PORTAL_SETTINGS) private portalConfig: PortalSettings) {}

  get portalSettings(): PortalSettings {
    return this.portalConfig;
  }

  goTo(link: string | undefined): void {
    if (!link) {
      return;
    }

    window.open(link, '_blank');
  }

  trackByLink(_: number, item: string) {
    return item;
  }
}
